// Persistence must never turn a successful upload/payment into a failed UI.
const memory = new Map<string, string | null>();
export function hairRead(key: string, area: "local" | "session" = "local") {
  if (memory.has(`${area}:${key}`)) return memory.get(`${area}:${key}`) ?? null;
  try { return (area === "local" ? localStorage : sessionStorage).getItem(key) ?? memory.get(`${area}:${key}`) ?? null; }
  catch { return memory.get(`${area}:${key}`) ?? null; }
}
export function hairWrite(key: string, value: string, area: "local" | "session" = "local") {
  memory.set(`${area}:${key}`, value);
  try {(area === "local" ? localStorage : sessionStorage).setItem(key,value);} catch { /* This visit still works. */ }
}
export function hairRemove(key: string, area: "local" | "session" = "local") {
  memory.set(`${area}:${key}`, null);
  try {(area === "local" ? localStorage : sessionStorage).removeItem(key);} catch { /* Optional persistence. */ }
}
